var $ = jQuery;

function init() {
  const $readMoreButton = $('.js-read-more__button');
  const $container = $('.js-read-more__container');
  const $target = $('.js-read-more__target');

  $container.css({'overflow': 'hidden'});
  $readMoreButton.removeClass('_inactive');

  if($readMoreButton.length > 0) {
    initReadMore();
  }

  function initReadMore() {
    binds();
    setArticleHeight();
  }

  function binds() {
    $(document).on('click', '.js-read-more__button', openArticle);
    $(window).on('resize',setArticleHeight);
  }

  function setArticleHeight() {
    let targetHeight = $target.outerHeight(true);
    $container.attr('data-height', targetHeight);
  }

  function openArticle(e) {
    let bodyHeight = $container.attr('data-height');

    $(window).off('resize', setArticleHeight);
    $readMoreButton.off('click', openArticle);

    $container.addClass('_article-open').css({
      'height': bodyHeight+'px'
    });

    $(this).addClass('_inactive');

    $container.one('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd', function(e) {
      $(this).css({'height' :'auto' , 'overflow' : 'visible'});
    });

    if ($('.event-calendar').length) {
      $(window).trigger('readMoreStickyScrubber');
    }
  }
}

export { init as init, init as readMoreInit };
